import { DragOverlay } from "@dnd-kit/core";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import { courseDraggingDataAtom, DragTypeStationEnum } from "@ryde/shared";

import { StationCourse } from "./station.course";

export const StationDragOverlayCourse: FC = () => {
  const courseDraggingData = useRecoilValue(courseDraggingDataAtom);
  const { type: dragType, payload: props } = courseDraggingData;
  return (
    dragType === DragTypeStationEnum.STATION && (
      <DragOverlay
        dropAnimation={null}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
      >
        <StationCourse
          key={props.station.id}
          station={props.station}
          courseDto={props.courseDto}
          isLastStation={false}
          isFirstStation={false}
          stationIndex={props.stationIndex}
          isDragClone={true}
        />
      </DragOverlay>
    )
  );
};
